import { PersonalGroupSyncStatus } from './groups'

export function shouldWaitForGoogleGroupSync(
  status?: string,
  revision?: string
): boolean {
  if (!status || status === 'null' || !revision || revision === 'null') {
    return false
  }

  return (
    status !== PersonalGroupSyncStatus.SYNCED &&
    status !== PersonalGroupSyncStatus.PRIVATE
  )
}
